<template>
  <UiEditLayout class="jps-mysearch-editor jps-layout-sm-content">
    <template #tools="">
      <UiEditLayoutButton v-if="editstate.undo" type="UNDO" @click="csEditor?.undo()" :disabled="!editstate.canUndo" />
      <UiEditLayoutButton v-if="editstate.redo" type="REDO" @click="csEditor?.redo()" :disabled="!editstate.canRedo" />
      <UiEditLayoutButton type="SAVE" @click="saveImpl()" :is-saving="isSaving" />
      <UiEditLayoutButton type="FINISH" @click="emits('finish')" :button-class="['is-primary']" />
    </template>
    <CsEditor
      ref="csEditor"
      :no-menu="true"
      v-if="undo.undoable"
      :editstate="editstate"
      @finish="emits('finish')"
    />
  </UiEditLayout>
</template>

<script lang="ts" setup>
import type { CsEditor } from '#components'

const csStore = useCsStore()
const { initCsForEdit } = useCsEditor()
const localSearchStore = useLocalSearchStore()

interface Props {
}
const props = withDefaults(defineProps<Props>(),{
})

const emits = defineEmits(['finish'])

const csEditor: Ref<InstanceType<typeof CsEditor> | null> = ref(null)

const entry: Ref<CsEntry> = ref(null)
const isSaving: Ref<boolean> = ref(false)
const saveImpl = async () => {
  isSaving.value = true
  try {
    const cs = clone(undo.undoable.value)
    cs.id = entry.value.id
    entry.value = await csStore.updateCs(cs)
  } catch (e) {
    console.info(e)
  } finally {
    isSaving.value = false
    undo.waitSaving.value = false
  }
}
const { editstate, undo }  = useCsSave({ mode: 'mysearch', saveImpl: saveImpl })

undo.autosaveEnabled.value = true
undo.undoable.value = null

const watchActiveCs = async () => {
  if (undo.undoable.value && undo.undoable.value.id === localSearchStore.activeMySearch)
    return
  if (undo.waitSaving.value) {
    await undo.forceSave()
  }
  undo.ignoreChange.value = true
  const et = await csStore.getCs(localSearchStore.activeMySearch)
  delete et.cs.edit
  initCsForEdit(et.cs)
  entry.value = et
  undo.undoable.value = et.cs
  undo.resetHistory()
}

onBeforeMount(() => {
  watchActiveCs()
})

watch(
  () => localSearchStore.activeMySearch,
  () => {
    watchActiveCs()
  }
)
</script>

<style lang="scss" scoped>
.jps-mysearch-editor {
  height: 100%;
  .saving-icon {
    position: fixed;
    bottom: 2rem;
    right: 2rem;
    z-index: 10;
  }
}
</style>
